export default __webpack_public_path__ + "static/media/Fairy_of_spring_Erica_Pagnoni_30_x_30.4d832615.jpg";